import React from "react";
import {Route, Redirect, RouteProps} from "react-router";
import {hasAccess, UserRoles} from "../util/UserUtil";

interface PrivateRouteProps extends RouteProps {
    component: React.ComponentType<any>;
    forRole?: UserRoles[];
}

export default function PrivateRoute(props: PrivateRouteProps) {
    const {component: Component, forRole, ...rest}: PrivateRouteProps = props;
    // const user = useUser();
    return (
        <Route
            {...rest}
            render={(props: any) =>
                hasAccess(forRole) ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{pathname: "/login", state: {referrer: props.location}}}
                    />
                )
            }
        />
    );
}
